// Корзина витрины: серверное хранилище, цена не хранится — считается
// по актуальному каталогу (docs/04-api-contract.md §3, docs/02-domain-model.md §6).
import type { ApiResponse } from "@shopkit/shared";

import { apiRequest } from "./client";

export type Cart = ApiResponse<"getCart">;
export type CartItem = Cart["items"][number];

/** getCart — корзина покупателя. Бросает ApiError. */
export function getCart(signal?: AbortSignal): Promise<Cart> {
  return apiRequest<Cart>("/api/v1/cart", { signal });
}

/**
 * putCartItem добавляет товар в корзину или меняет его количество; qty=0
 * убирает позицию. 422 — qty вне диапазона 0..999 или товар недоступен.
 * Бросает ApiError.
 */
export function putCartItem(productId: string, qty: number, signal?: AbortSignal): Promise<Cart> {
  return apiRequest<Cart>(`/api/v1/cart/items/${productId}`, {
    method: "PUT",
    signal,
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ qty }),
  });
}

/** clearCart — полностью очищает корзину покупателя. Бросает ApiError. */
export function clearCart(signal?: AbortSignal): Promise<void> {
  return apiRequest<void>("/api/v1/cart", { method: "DELETE", signal });
}
